import {
    DocumentType,
    FirePermitCalendarReadDTO,
    IS37CalendarReadDTO,
    LockoutCalendarReadDTO,
    NdcCalendarReadDTO,
    RpAssessmentWithDimrCalendarReadDTO,
    VicCalendarReadDTO,
} from '../../api/dto';

export enum ZoomLevel {
    DAYS,
    MONTHS,
}

export enum DateRange {
    SEVEN_DAYS = 7,
    THIRTY_DAYS = 30,
    THREE_HUNDRED_SIXTY_FIVE_DAYS = 365,
}

export interface GanttDocument {
    id: string;
    type: DocumentType;
    text: string;
    description: string | null;
    start_date: Date;
    end_date: Date;
    duration: number;
    responsible: string;
    [key: string]: unknown;
    section: string;
    color: string;
    notesDeCoupure: NdcCalendarReadDTO[];
    is37s: IS37CalendarReadDTO[];
    vics: VicCalendarReadDTO[];
    lockouts: LockoutCalendarReadDTO[];
    firePermits: FirePermitCalendarReadDTO[];
    rpAssessment: RpAssessmentWithDimrCalendarReadDTO | null;
    showArrow?: boolean;
}

export interface GanttLink {
    id: string | number;
    source: string | number;
    target: string | number;
    type: string;
    [key: string]: unknown;
}

export interface CalendarProps {
    activities: { data: GanttDocument[]; links: GanttLink[]; lastUpdated: Date };
    zoom: ZoomLevel;
    startDate: Date;
    endDate: Date;
    dateFormat: string;
}

export interface ToolbarProps {
    zoom: ZoomLevel;
    startDate: Date;
    endDate: Date;
    includeLongLasting: boolean;
    onZoomChange: (level: ZoomLevel) => void;
    onStartChange: (iso: Date) => void;
    onEndChange: (iso: Date) => void;
    onIncludeLongLastingChange: (value: boolean) => void;
    dateFormat: string;
}

export type RGB = {
    r: number;
    g: number;
    b: number;
};
